import React from 'react';
import { FormControlLabel, FormControl, makeStyles } from '@material-ui/core';

import { FormHookResult } from '../../../validation';
import { generateProperties } from '../helpers';

import { Body2Text } from '../../TextVariants';
import CustomCheckbox from '../../General/CustomCheckbox/CustomCheckbox';

const useStyles = makeStyles({
  root: {
    alignItems: 'flex-start',
  },
});

type Props = {
  checkTitle?: React.ReactNode;
  checkName: string;
  disabled?: boolean;
  defaultValue?: boolean;
  inputId?: string;
  onChange?: (val: boolean) => void;
  dataSource?: FormHookResult<boolean>;
  style?: React.CSSProperties;
};

const CheckBox = ({
  style,
  inputId,
  checkTitle = '',
  checkName,
  disabled = false,
  defaultValue = false,
  onChange,
  dataSource,
}: Props): JSX.Element => {
  const classes = useStyles();
  const formInputProps = generateProperties<boolean>({
    inputName: checkName,
    onChange,
    defaultValue,
    dataSource,
  });

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    formInputProps.onChange(event.target.checked);
  };

  const usedLabel =
    typeof checkTitle === 'string' ? (
      <Body2Text data-testid="local-styled-label">{checkTitle}</Body2Text>
    ) : (
      checkTitle
    );

  return (
    <FormControl component="fieldset" fullWidth disabled={disabled}>
      <FormControlLabel
        label={usedLabel}
        data-testid={checkName}
        disabled={disabled}
        control={
          <CustomCheckbox
            id={inputId}
            onChange={handleChange}
            name={formInputProps.name}
            color="primary"
            checked={formInputProps.value}
          />
        }
        classes={{
          root: classes.root,
        }}
        style={style}
      />
    </FormControl>
  );
};

export default CheckBox;
